module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Scene":{"widgets.sceneViewer.widgets.currentScene.list.handleDom.downloadLinks.eventChecker":[{"value":function (e, elm, w) {
return window.parseInt(w.dl.getObjectValue('accessibility.downloadable'));
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101009},"path":"~.SitePage_Scene","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/downloadLinks.js
// module id = 662
// module chunks = 4